import Button from "common/Buttons/Button";
import React from "react";
import styled, { css } from "styled-components";

interface TwoFAFooterProps {
  onClick?: () => void;
  children: string;
  isLoading?: boolean;
  disabled?: boolean;
  isSubmit?: boolean;
}

export const TwoFAFooter = ({
  onClick,
  isLoading,
  children,
  disabled,
  isSubmit,
}: TwoFAFooterProps) => (
  <Wrapper>
    <Button
      type="primary"
      style={{ width: 150 }}
      loading={isLoading}
      onClick={onClick}
      disabled={disabled}
      htmlType={isSubmit ? "submit" : "button"}
    >
      {children}
    </Button>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 50px;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      position: static;
      align-self: stretch;
      justify-content: flex-end;
      /* With the step's 16px gap: 20 above the divider, 20 to the button,
         and the panel's 20 below it. */
      margin-top: 4px;
      padding-top: 20px;
      border-top: ${p.theme.borders.lightest};
      @media (max-width: 500px) {
        .ant-btn {
          flex: 1;
        }
      }
    `}
`;
